import { createSlice } from '@reduxjs/toolkit';
import PersistStorage from '../../utils/helpers/PersistStorage';

const initialState = {
    AspDotNetCoreURL: "",
    MainAPIURL: "",
    CurrentApplicationVersion:"",
    ConfigurationsLoaded: false,
    GenericManifestDotNetCoreURL:"",
    GenericReportingURL:"",
    CallCenterCoreURL:"",
    REACT_APP_MRMS_REPORTING_API:"",
    ManifestForceAssignRejectLoaderTime: "",
    ManifestRouteSuggestionRejectLoaderTime: "",
    PatchAppliedDate: "",
    InActivityTimeInMinutes: ""
}
const GetApplicableURLs = function(){
    let _ApplicationVersion = window.AppConfigurations["REACT_APP_VERSION"];
    let _REACT_APP_MRMS_REPORTING_API = window.AppConfigurations["default"]["REACT_APP_MRMS_REPORTING_API"];
    let _REACT_APP_PYTHON_URL = window.AppConfigurations["default"]["REACT_APP_PYTHON_URL"];
    let _REACT_APP_ASPDOTNETCOREURL = window.AppConfigurations["default"]["REACT_APP_ASPDOTNETCOREURL"];
    let _REACT_APP_GENERIC_MANIFEST_API = window.AppConfigurations["default"]["REACT_APP_GENERIC_MANIFEST_API"];
    let _REACT_APP_GENERIC_REPORT_API = window.AppConfigurations["default"]["REACT_APP_GENERIC_REPORT_API"];
    let _EXTERNAL_DISPATCH_API = window.AppConfigurations["default"]["EXTERNAL_DISPATCH_API"];
    let _REACT_APP_RESERVATION_API = window.AppConfigurations["default"]["REACT_APP_RESERVATION_API"];
    let _ManifestForceAssignRejectLoaderTime = window.AppConfigurations["ManifestForceAssignRejectLoaderTime"];
    let _ManifestRouteSuggestionRejectLoaderTime = window.AppConfigurations["ManifestRouteSuggestionRejectLoaderTime"];
    let _ApplicationPatchAppliedDate = window.AppConfigurations["PATCH_APPLIED_DATE"];
    let _InActivityTimeInMinutes = window.AppConfigurations["INACTIVITY_TIME_IN_MINUTES"];
    
    try{
        let configfound = false;
        let currURLL = window.location.hostname.toString();
        for (let key in window.AppConfigurations) {
            let ConfObject = window.AppConfigurations[key];
            if (ConfObject.hasOwnProperty("ApplicableURLsKeywords")){
                for (let i = 0; i < ConfObject["ApplicableURLsKeywords"].length; i++) {
                    if(currURLL.indexOf(ConfObject["ApplicableURLsKeywords"][i]) > -1){
                        _REACT_APP_MRMS_REPORTING_API = ConfObject["REACT_APP_MRMS_REPORTING_API"];
                        _REACT_APP_PYTHON_URL = ConfObject["REACT_APP_PYTHON_URL"];
                        _REACT_APP_ASPDOTNETCOREURL = ConfObject["REACT_APP_ASPDOTNETCOREURL"];
                        _REACT_APP_RESERVATION_API = ConfObject["REACT_APP_RESERVATION_API"];
                        _REACT_APP_GENERIC_MANIFEST_API = ConfObject["REACT_APP_GENERIC_MANIFEST_API"];
                        _REACT_APP_GENERIC_REPORT_API = ConfObject["REACT_APP_GENERIC_REPORT_API"];
                        _EXTERNAL_DISPATCH_API = ConfObject["EXTERNAL_DISPATCH_API"];
                        configfound = true;
                        break;
                    }
                  }
                  if(configfound){
                    break;
                  }
            }
        }
    }
    catch(ext) { }
    return {
        "version": _ApplicationVersion,
        "REACT_APP_MRMS_REPORTING_API": _REACT_APP_MRMS_REPORTING_API, 
        "REACT_APP_PYTHON_URL": _REACT_APP_PYTHON_URL,
        "REACT_APP_ASPDOTNETCOREURL":_REACT_APP_ASPDOTNETCOREURL, 
        "REACT_APP_GENERIC_MANIFEST_API": _REACT_APP_GENERIC_MANIFEST_API,
        "REACT_APP_GENERIC_REPORT_API": _REACT_APP_GENERIC_REPORT_API,
        "REACT_APP_RESERVATION_API": _REACT_APP_RESERVATION_API,
        "ManifestForceAssignRejectLoaderTime": _ManifestForceAssignRejectLoaderTime,
        "ManifestRouteSuggestionRejectLoaderTime": _ManifestRouteSuggestionRejectLoaderTime,
        "Patch_Date": _ApplicationPatchAppliedDate,
        "Inactivity_Time": _InActivityTimeInMinutes,
        "EXTERNAL_DISPATCH_API": _EXTERNAL_DISPATCH_API
    }
}
const configurationSlice = createSlice({
    name: "configuration",
    initialState,
    reducers: {
        resetConfiguration: (state) => {
            var _configs = GetApplicableURLs();
            state.MainAPIURL = _configs.REACT_APP_PYTHON_URL;
            state.ReservationCoreURL = _configs.REACT_APP_RESERVATION_API;
            state.AspDotNetCoreURL = _configs.REACT_APP_ASPDOTNETCOREURL;
            state.GenericManifestDotNetCoreURL = _configs.REACT_APP_GENERIC_MANIFEST_API;
            state.GenericReportingURL = _configs.REACT_APP_GENERIC_REPORT_API;
            state.ConfigurationsLoaded = true;
            state.CurrentApplicationVersion = _configs.version;
            state.REACT_APP_MRMS_REPORTING_API = _configs.REACT_APP_MRMS_REPORTING_API;
            state.ManifestForceAssignRejectLoaderTime = _configs.ManifestForceAssignRejectLoaderTime;
            state.ManifestRouteSuggestionRejectLoaderTime = _configs.ManifestRouteSuggestionRejectLoaderTime;
            state.PatchAppliedDate = _configs.Patch_Date;
            state.InActivityTimeInMinutes = _configs.Inactivity_Time;
            state.EXTERNAL_DISPATCH_API = _configs.EXTERNAL_DISPATCH_API;
        },
        resetGridRefreshConfiguration: (state) => {
            let IsDriverActionDialogOpened = PersistStorage.retrieve("IsDriverActionsDialogOpened", false);
            if(IsDriverActionDialogOpened != undefined && IsDriverActionDialogOpened != null){
                PersistStorage.save("IsDriverActionsDialogOpened", false, 0, false);
            }
        }
    }
});

export const { resetConfiguration, resetGridRefreshConfiguration } = configurationSlice.actions;
export default configurationSlice.reducer;